import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './pendingCard.module.scss';
import ToolTip from '@/components/ToolTip/ToolTip';
import Skeletons from '@/components/Skeletons/Skeletons';
import { TRACK_ELEMENT } from '../../constants/track';
import { useDndCardContext } from '../../DndCard/context';

const PendingCard = forwardRef(({ children, loading = true, ...rest }, ref) => {
  const renderSkeletons = () =>
    Array.from({ length: 5 }).map((_, index) => (
      <Skeletons
        key={index} // eslint-disable-line react/no-array-index-key
        height={!index ? 20 : 72}
        width={!index ? 300 : '100%'}
      />
    ));

  return (
    <Box ref={ref} className={styles.cardContainer} {...rest}>
      {loading ? renderSkeletons() : children}
    </Box>
  );
});

PendingCard.Header = function PendingCardHeader({
  children,
  toolTipText,
  infoTooltipText = '',
  redirectUrl = '',
  trackCallback = null,
}) {
  const { edition } = useSelector((state) => state.DashboardSlice);
  const { visible: dndVisible } = useDndCardContext();

  const handleRedirect = () => {
    window.open(redirectUrl, '_blank');

    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.SHOW_ALL);
    }
  };

  return (
    <Box className={styles.headerContainer}>
      <Box className={styles.headerLeft}>
        {edition.active && dndVisible && (
          <Icon
            className={styles.hiddenIcon}
            icon="icon-menu"
            fontSize="12px"
          />
        )}
        <Text className={styles.headerText}>{children}</Text>
        {infoTooltipText && !edition.active && (
          <ToolTip
            title={infoTooltipText}
            tipClassName={styles.headerInfoTooltip}
          >
            <Box className={styles.headerInfoIconWrapper}>
              <Icon icon="icon-info" fontSize="16px" />
            </Box>
          </ToolTip>
        )}
      </Box>
      {redirectUrl && !edition.active && (
        <ToolTip title={toolTipText}>
          <Icon
            className={styles.headerIcon}
            onClick={handleRedirect}
            icon="icon-ir"
            fontSize="16px"
          />
        </ToolTip>
      )}
    </Box>
  );
};

export default PendingCard;
